module.exports = __webpack_public_path__ + "static/media/4678.e2236f0d.jpg";